import React, { Component, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { VersionIndicator } from './../../core/versioning'
import AdminNavLinks from './AdminNavLinks.component'
import AgentNavLinks from './AgentNavLinks.component'
import LoadingSpinner from './../shared/LoadingSpinner.component'
import StorageService from './../../shared/services/Storage.service'
import DashboardHeader from './DashboardHeader.component'
import LoadingService from './../../shared/services/Loading.service'
import { Subscription } from 'rxjs'
import {
  MDBSideNavItem,
  MDBSideNav,
  MDBBtn,
  MDBSideNavMenu,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from 'mdb-react-ui-kit'
// import { MDBSideNavNav, MDBSideNav, MDBBtn } from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import AuthService from './../../shared/services/Auth.service'
import UserProfileService from './../../shared/services/UserProfile.service'
import appConstants from './../../constants/appConstants'
import { isWhiteLabel, getWhiteLabelLogo } from './../../shared/utilities/whiteLabel.function'
import ContentVideo from './../content/ContentVideo/ContentVideo.component'
import { Container as PromiseModalContainer } from 'react-modal-promise'
import DashboardOverlay from './DashboardOverlay.component'
import AgentPushBanner from './../push/AgentPushBanner'
import UpdatePaymentMethodModal from '../modals/UpdatePaymentMethodModal/UpdatePaymentMethodModal.component'

import './DashboardLayout.scss'

const ENABLE_LOADING_SERVICE = false

const SIDEBAR_BREAKPOINT = '(max-width: 1299.98px)'

// Above the breakpoint the nav is docked open and the header's toggle is hidden;
// below it, it's an overlay that starts closed. DashboardLayout is mounted by each
// page rather than once at the router, so every navigation remounts it — this has to
// resolve synchronously, during construction, or the first render paints the nav
// closed and MDBSideNav replays its 0.3s slide-in on every page change.
const isSidebarDocked = () => typeof window === 'undefined' || !window.matchMedia(SIDEBAR_BREAKPOINT).matches

const UnassumeUserIdentityButton = ({ adminName, onLogout }) => {
  const [isUnassuming, setIsUnassuming] = useState(false)

  const unassume = async () => {
    setIsUnassuming(true)

    let path, error
    try {
      path = await AuthService.unassumeUser()
    } catch (ex) {
      error = `${ex}`
    }

    setIsUnassuming(false)
    onLogout(path, error)
  }

  const renderButton = () => {
    if (UserProfileService.isAssumed() || isUnassuming)
      return (
        <div className='unassume-user-identity-btn pb-5'>
          <MDBBtn
            type='button'
            color='default'
            title={`Back to ${adminName}`}
            className='text-truncate btn-block aqua-gradient'
            disabled={isUnassuming}
            onClick={unassume}
            sm='true'
          >
            {isUnassuming ? (
              <>
                <i className='fa fa-spin fa-spinner'></i>&nbsp;Logging Out...
              </>
            ) : (
              <>Back to {adminName}</>
            )}
          </MDBBtn>
        </div>
      )
    return <></>
  }

  return <>{renderButton()}</>
}

class DashboardLayout extends Component {
  _adminName = ''
  sideNavRef = React.createRef()

  state = {
    showSidebarNav: isSidebarDocked(),
    isSidebarDocked: isSidebarDocked(),
    isLoadingActive: false,
    userData: {},
    showOwnerVideoModal: false,
    location: {},
  }

  __subscriptions$ = new Subscription()

  componentDidMount() {
    if (typeof window !== 'undefined') if (!StorageService.get('user_fb')) return this._goTo('/')

    let userDetails = UserProfileService.getUserDetails(true)
    userDetails = userDetails && [userDetails?.u_fname, userDetails?.u_lname].join(' ').trim()
    this._adminName = userDetails ? userDetails : 'My Account'

    if (ENABLE_LOADING_SERVICE)
      this.__subscriptions$.add(LoadingService.getActive().subscribe(isActive => this._setLoadingActive(isActive)))
    this._fetchUserRoles()

    this.mediaQueryList = window.matchMedia(SIDEBAR_BREAKPOINT)
    this.mediaQueryList.addEventListener('change', this._handleViewportChange)
    document.addEventListener('click', this._handleDocumentClick, true)
  }

  _setSidebarNav = showSidebarNav => {
    if (showSidebarNav !== this.state.showSidebarNav) this.setState({ showSidebarNav })
  }

  _handleDocumentClick = event => {
    const isSmallScreen = window.innerWidth < 1300
    const sidebarNode = this.sideNavRef?.current
    if (isSmallScreen && this.state.showSidebarNav && sidebarNode && !sidebarNode.contains(event.target)) {
      this._setSidebarNav(false)
    }
  }

  _handleViewportChange = e => {
    this.setState({ isSidebarDocked: !e.matches })
    this._setSidebarNav(!e.matches) // false if small screen
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.location.search !== this.props.location.search
    ) {
      // Only update state if the location values actually changed
      // Create a new object to avoid reference issues
      this.setState({
        location: {
          pathname: this.props.location.pathname,
          search: this.props.location.search,
          hash: this.props.location.hash,
          state: this.props.location.state,
        },
      })
    }
  }

  componentWillUnmount() {
    this.__subscriptions$.unsubscribe()
    this.mediaQueryList?.removeEventListener('change', this._handleViewportChange)
    document.removeEventListener('click', this._handleDocumentClick, true)
  }

  _goTo = (location, opt) => {
    if (location && typeof location === 'object' && location?.url) location = location?.url

    if (location && typeof location === 'string') {
      if (/^(http:|https:)/.test(location)) {
        window.open(location)
        return
      }

      if (ENABLE_LOADING_SERVICE) {
        LoadingService.setLabel(opt && opt.name)
        LoadingService.on()
      }

      if (this.props.location.pathname.includes('/reporting/') && location.includes('/reporting/')) {
        this.props.history.push('/dashboard')
        setTimeout(() => {
          this.props.history.push(location)
        }, 0)
      } else this.props.history.push(location)
    }
  }

  _setLoadingActive = isLoadingActive => {
    if (isLoadingActive !== this.state.isLoadingActive) this.setState({ isLoadingActive })
  }

  _toggleNav = () => this._setSidebarNav(!this.state.showSidebarNav)

  _openOwnerVideoModal = () => this.setState({ showOwnerVideoModal: true })

  _closeOwnerVideoModal = () => this.setState({ showOwnerVideoModal: false })

  _handleSideNavOpenState = val => this._setSidebarNav(val)

  _fetchUserRoles = async () => {
    let userDetails = await UserProfileService.getUserDetailsFromAPI()

    if (parseInt(userDetails.u_active) !== 1 && !UserProfileService.isAssumed()) {
      await AuthService.logout()
      toast.success('Logout Successful')
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000)
    }

    AdminApi.fetchUserDetailsAuth()
      .then(result => {
        let userData = result && result.data && result.data.data ? result.data.data : false
        if (userData) {
          userData.usertype_id = parseInt(userData.usertype_id)
          this.setState({ userData })
        }
      })
      .catch(error => {
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  _handleLogout = (path, error) => {
    if (path && path === this.props.location.pathname) window.location.reload()
    else if (path) this.props.history.push(path)
    else {
      toast.error("Oh no!  We were unable to you out of the agent's account.  Logging out entirely.", {
        position: toast.POSITION.TOP_RIGHT,
      })
      AuthService.logout()
      this.props.history.push('/login')
    }
  }

  renderCtaBtn = () => {
    if (parseInt(UserProfileService.get('has_onboarded')) !== 1)
      return (
        <MDBSideNavItem style={{ padding: '15px 5px 5px 5px' }}>
          <MDBBtn type='button' size='lg' block color='danger' onClick={() => this._goTo('/welcome')}>
            COMPLETE MY
            <br />
            AGENT ONBOARDING
          </MDBBtn>
        </MDBSideNavItem>
      )

    // Upgrade Agent Usertype.
    // UAD-3667: white-label downline agents can't upgrade to Signature — hide it.
    if (
      !isWhiteLabel() &&
      UserProfileService.isA(['affiliate-group', 'associate-group']) &&
      parseInt(UserProfileService.get('can_upgrade_signature')) !== 1
    )
      return (
        <MDBSideNavItem style={{ padding: '15px 5px 5px 5px' }}>
          <MDBBtn
            type='button'
            className='pl-2 pr-2 mx-auto'
            style={{ width: '100%' }}
            color='danger'
            onClick={() => this._goTo('/account-billinginfo')}
            size='lg'
          >
            Upgrade To Signature Agent
          </MDBBtn>
        </MDBSideNavItem>
      )
    return <></>
  }

  render() {
    toast.configure()

    const ownerWelcomeTitle = this.props.ownerWelcomeTitle ?? 'USABG Welcome'

    // White-label downline agents see their leader's brand logo instead of USABG.
    const isWl = isWhiteLabel()
    const whiteLabelLogo = isWl ? getWhiteLabelLogo(UserProfileService.get('white_label_logo')) : false

    return (
      <div id='DashboardLayoutComponent' className='indigo-skin'>
        <UpdatePaymentMethodModal />

        <MDBModal
          className='DashboardLayout__owner-video-modal'
          open={this.state.showOwnerVideoModal}
          onClose={this._closeOwnerVideoModal}
          tabIndex='-1'
        >
          <MDBModalDialog size='fluid'>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{ownerWelcomeTitle}</MDBModalTitle>
                <MDBBtn type='button' className='btn-close' color='none' onClick={this._closeOwnerVideoModal}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className='DashboardLayout__owner-video-modal-body'>
                <div className='DashboardLayout__owner-video-wrapper'>
                  <ContentVideo contentSlug='owner-welcome-video' />
                </div>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
        <div id='DashboardLayoutSidebar' ref={this.sideNavRef}>
          <MDBSideNav
            open={this.state.showSidebarNav}
            mode='side'
            closeOnEsc={!this.state.isSidebarDocked}
            getOpenState={this._handleSideNavOpenState}
          >
            <MDBSideNavMenu>
              <MDBSideNavItem>
                {isWl && !whiteLabelLogo ? (
                  <></>
                ) : (
                  <img
                    alt={ownerWelcomeTitle}
                    src={whiteLabelLogo || appConstants.logos.master.sm}
                    className='mx-auto d-block img-fluid cursor-pointer'
                    style={whiteLabelLogo ? { maxHeight: '90px', width: 'auto' } : undefined}
                    onClick={this._openOwnerVideoModal}
                  />
                )}
              </MDBSideNavItem>
              {this.renderCtaBtn()}
              <MDBSideNavItem className='agent-nav-links-link'>
                <AgentNavLinks goTo={this._goTo} />
              </MDBSideNavItem>
              <AdminNavLinks goTo={this._goTo} />
              {/*<MDBSideNavNav className='pb-5'>*/}
              <MDBSideNavItem className='unassume-user-link'>
                <UnassumeUserIdentityButton adminName={this._adminName} onLogout={this._handleLogout} />
              </MDBSideNavItem>
              {isWl ? <></> : <VersionIndicator />}
            </MDBSideNavMenu>
          </MDBSideNav>
        </div>

        {/*<DashboardHeader goTo={this._goTo} userData={this.state.userData} profileImage={this.state.userData.u_picture && this.state.imageURLs.prefix && this.state.imageURLs.suffix ? this.state.imageURLs.prefix+this.props.userData.u_picture+this.state.imageURLs.suffix : null} />*/}
        <div id='main-content'>
          <DashboardHeader
            toggleNav={this._toggleNav}
            goTo={this._goTo}
            userData={this.state.userData}
            urlParams={this.props.match.params}
            location={this.state.location}
          />
          <div id='page-content' className={this.state.isLoadingActive ? 'is-loading' : ''}>
            {ENABLE_LOADING_SERVICE && <LoadingSpinner size='md' />}
            {/* Unacknowledged CRITICAL messages from BST. Renders null unless
                there are any, and dismissing it acknowledges the message. */}
            <AgentPushBanner />
            {this.props.children}
            <DashboardOverlay />
          </div>
        </div>

        <PromiseModalContainer />
      </div>
    )
  }
}

export default withRouter(DashboardLayout)
